import { useState, useCallback } from 'react';

export const useAccordionState = (
  controlledExpanded: boolean | undefined,
  defaultExpanded: boolean = false,
  onChange?: (event: React.SyntheticEvent, isExpanded: boolean) => void
) => {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);

  const isControlled = controlledExpanded !== undefined;
  const isExpanded = isControlled ? controlledExpanded : internalExpanded;

  const handleChange = useCallback(
    (event: React.SyntheticEvent, newExpanded: boolean) => {
      if (!isControlled) {
        setInternalExpanded(newExpanded);
      }
      onChange?.(event, newExpanded);
    },
    [isControlled, onChange]
  );

  return {
    isExpanded,
    handleChange
  };
};
